import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AnalyticsService } from './analytics.service';

export interface BookingModalPayload {
  isOpen: boolean;
  serviceId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BookingModalService {
  private modalSubject = new BehaviorSubject<BookingModalPayload>({ isOpen: false });
  public modal$ = this.modalSubject.asObservable();

  constructor(private analytics: AnalyticsService) {}

  /** Keep legacy observable for any existing subscribers */
  public get isOpen$() {
    return new BehaviorSubject<boolean>(this.modalSubject.value.isOpen).asObservable();
  }

  open(serviceId?: string) {
    this.modalSubject.next({ isOpen: true, serviceId });
    document.body.style.overflow = 'hidden';
    this.analytics.trackLead('quote_cta_click', serviceId ? { service: serviceId } : {});
  }

  close() {
    this.modalSubject.next({ isOpen: false });
    document.body.style.overflow = 'auto';
  }
}
